var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackFinanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2499 15.1666C19.2499 15.4888 18.9888 15.7499 18.6666 15.7499C18.3444 15.7499 18.0833 15.4888 18.0833 15.1666C18.0833 14.8444 18.3444 14.5833 18.6666 14.5833C18.9888 14.5833 19.2499 14.8444 19.2499 15.1666Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54175 7.87508V20.1251C5.54175 21.4137 6.58642 22.4584 7.87508 22.4584H20.1251C21.4137 22.4584 22.4584 21.4137 22.4584 20.1251V11.6251C22.4584 10.5205 21.563 9.62508 20.4584 9.62508H20.1251M20.1251 9.62508H7.58341C6.45583 9.62508 5.54175 8.711 5.54175 7.58341C5.54175 6.45583 6.45583 5.54175 7.58341 5.54175H17.7917C19.0804 5.54175 20.1251 6.58642 20.1251 7.87508V9.62508Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackFinanceIcon);
export default __webpack_public_path__ + "static/media/black_finance_icon.cd8f0b39537ca896fdbf09d80ed1cbbe.svg";
export { ForwardRef as ReactComponent };